import { useQuery } from '@tanstack/react-query';
import { getShopPageFormulas, getShopPageTests } from './ContentfulFetcher';
import { QUERY_KEYS } from '../config';

export function useGetShopPageTests(options: Record<string, unknown> = {}) {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_TEST_KIT],
    queryFn: async () => {
      const response = await getShopPageTests(options);
      return response;
    },
  });
}

export function useGetShopPageFormulas(options: Record<string, unknown> = {}) {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_FORMULAS],
    queryFn: async () => {
      const response = await getShopPageFormulas(options);
      return response;
    },
  });
}
